import { schema, types } from 'papr'

export const WEBHOOK_EVENT = [
	'post_published' as const,
	'post_updated' as const,
	'post_deleted' as const,
	'static_page_published' as const,
	'static_page_edited' as const,
	'static_page_deleted' as const,
]

export type WebhookEvent = (typeof WEBHOOK_EVENT)[number]

export const webhookConfigSchema = schema({
	publication: types.objectId({ required: true }),
	url: types.string({ required: true }),
	events: types.array(types.enum(WEBHOOK_EVENT, { required: true }), {
		required: true,
	}),
	/** Secret that will be used for signing the requests. */
	secret: types.string({ required: true }),
	dateAdded: types.date({ required: true }),
	dateUpdated: types.date(),
})

export type WebhookConfigDocument = (typeof webhookConfigSchema)[0]
export type WebhookConfigSchemaOptions = (typeof webhookConfigSchema)[1]
